import CircularProgress from '@mui/material/CircularProgress'
import styles from './Loader.pcss'

const SIZE_SMALL = 60
export interface LoaderProps {
  title?: string
  className?: string
  pp?: boolean
  size?: number
  small?: boolean
}

export function Loader(props: LoaderProps) {
  const style: any = {}
  const styleDefault: any = {}
  if (props.small) {
    style.width = `${SIZE_SMALL}px`
    styleDefault.width = `${SIZE_SMALL}px`
    styleDefault.height = `${SIZE_SMALL}px`
  } else if (props.size) {
    style.width = `${props.size}px`
    styleDefault.width = `${props.size}px`
    styleDefault.height = `${props.size}px`
  }

  return (
    <div data-title={props.title} className={styles.wrapper} data-testid="loader">
      {!props.pp ? (
        <CircularProgress
          color="primary"
          style={styleDefault}
          className={`${styles.loader} ${props.className || ''}`}
        />
      ) : (
        <img
          className={`${styles.img} ${props.className || ''}`}
          src="/static/img/pp-loader.gif"
          style={style}
        />
      )}
    </div>
  )
}

export default Loader
